import React from 'react'
import PropTypes from 'prop-types'
import titleize from 'titleize'
import { withRouter } from 'react-router-dom'

import { commaStyleString } from '../../../../common/utils/formatString'
import { getRelAttributeValue } from '../../../../common/utils/seo'
import pushHistory from '../../../../common/utils/location/pushHistory'

import Checkbox from './checkbox'

import styles from './index.module.css'

class FiltersMultiselect extends React.Component {
  static propTypes = {
    locationParams: PropTypes.object.isRequired,
    makeSearchLink: PropTypes.func.isRequired,
    currentSite: PropTypes.string,
    items: PropTypes.array,
    type: PropTypes.string,
    labels: PropTypes.object,
    toLowerCasedLabel: PropTypes.bool
  }

  static defaultProps = {
    labels: {}
  }

  constructor(props) {
    super(props)

    this.state = {
      selectedOptions: this.parseSelectedOptions(props),
      colored: props.type === 'colors'
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      selectedOptions: this.parseSelectedOptions(nextProps)
    })
  }

  buildCheckboxLabel(labels, item) {
    const { toLowerCasedLabel } = this.props
    const labelsMap = labels ? new Map(Object.entries(labels)) : new Map()
    const label =
      item.label || labelsMap.get(item.key) || item.key || titleize(item.key)
    const finalLabel = toLowerCasedLabel ? label.toLowerCase() : label
    const labelContent = (
      <span>
        {finalLabel} <span className={styles.labelDetail}>{item.sublabel}</span>
      </span>
    )

    return labelContent
  }

  parseSelectedOptions(props) {
    const { locationParams } = props
    const parsedOptions = locationParams[props.type]
    return parsedOptions !== undefined ? parsedOptions.split(',') : []
  }

  removeSelectedOption(option) {
    return this.state.selectedOptions.filter(opt => {
      return opt !== option
    })
  }

  optionSelected(option) {
    return this.state.selectedOptions.indexOf(option) >= 0
  }

  onSelectionChange(option, event) {
    let { selectedOptions } = this.state

    event.preventDefault()

    let options = this.optionSelected(option)
      ? this.removeSelectedOption(option)
      : [...selectedOptions, option]

    this.setState({ selectedOptions: options }, this.onSelectionUpdate)
  }

  onSelectionUpdate() {
    const { selectedOptions } = this.state
    const { locationParams, makeSearchLink, type } = this.props

    let newQuery = Object.assign({}, locationParams)
    newQuery[type] = selectedOptions.join(',')

    // reset page param
    delete newQuery.page

    pushHistory(this.props.history, makeSearchLink(newQuery) + '#content')
  }

  createCheckboxes(items) {
    const { selectedOptions } = this.state
    const {
      locationParams,
      currentSite,
      makeSearchLink,
      type,
      labels
    } = this.props

    return items.map(item => {
      let newQuery = { ...locationParams }
      // reset page param
      delete newQuery.page

      const isCurrentOptionSelected = selectedOptions.includes(item.key)

      newQuery[type] = isCurrentOptionSelected
        ? selectedOptions.filter(option => option !== item.key).join(',')
        : [item.key, ...selectedOptions].join(',')

      const link = makeSearchLink(newQuery) + '#content'

      return (
        <Checkbox
          link={link}
          key={item.key}
          value={item.key}
          color={this.state.colored && item.key}
          count={commaStyleString(item.count)}
          onSelectionChange={this.onSelectionChange.bind(this)}
          checked={this.optionSelected(item.key)}
          rel={getRelAttributeValue(item.count, newQuery, currentSite)}
        >
          {this.buildCheckboxLabel(labels, item)}
        </Checkbox>
      )
    })
  }

  render() {
    let { items } = this.props
    return (
      <div className={styles.optionsWrapper}>
        {this.createCheckboxes(items)}
      </div>
    )
  }
}

export const FiltersMultiselectComponent = FiltersMultiselect
export default withRouter(FiltersMultiselect)
